import React from 'react';
import { isEmailPreviewContext } from '../utils/emailPreviewContext';
import OpenInBrowserScreen from './OpenInBrowserScreen';

export default function EmailPreviewGate({ children }) {
  if (isEmailPreviewContext()) {
    return <OpenInBrowserScreen />;
  }
  return children;
}
